import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import {LoadingSlim} from "../../Loading";

const useStyles = makeStyles(theme => ({
  cell: {
    height: "100%",
    textAlign: "center",
    border: "none"
  },
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));

const Loading = () => {
  const classes = useStyles();

  return (
    <div className="d-flex h-100">
      <Table className="h-100">
        <TableBody className="h-100">
          <TableRow className="h-100">
            <TableCell className={classes.cell}>
              <div className={classes.container}>
                <LoadingSlim className="c-mh3" size="sm" message="加载中" />
              </div>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
};

export {Loading};
